var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('main-header'),_c('sub-header')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }